import { Component, OnInit, Input } from "@angular/core";
import { CustCard_3 } from "src/classes/Customers/CustCard_3";
import { CustCard_1, CustomerIn } from "src/classes/Customers/CustCard_1";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { CustomCategory } from "src/classes/Customers/Customer";
import { SetValid } from "src/classes/Common/SetValid";
import { Config } from "src/classes/Common/ConfigData";
import { Router } from "@angular/router";
import { CustCardTabService } from "src/app/services/Custcard/cust-card-tab/cust-card-tab.service";
import { MessageService } from "primeng/api";
import { MainScrollService } from "src/app/services/Common/main-scroll.service";
import { ControlsService } from "src/app/services/Common/controls.service";
import { NGXLogger } from "ngx-logger";


@Component({
    selector: "app-custcardview57",
    templateUrl: "./custcardview57.component.html",
    styleUrls: ["./custcardview57.component.css"],
    providers: [HttpServiceCustomer, MessageService]
})
export class Custcardview57Component implements OnInit {
    custcard_3: CustCard_3 = new CustCard_3();
    // custcard_1: CustCard_1 = new CustCard_1();
    customerin: CustomerIn = new CustomerIn();
    receivedvalid: SetValid = new SetValid();
    config: Config;
    customClassificationData: { id: number, name: string }[] = [];

    customCategories: CustomCategory[];
    categoriesArray: CustomCategory[] = [];

    sexData: string[] = ["בחר", "לא מוגדר", "אישה", "גבר"];
    sexdesc: string;

    isFbLinkValid: boolean = false;
    isInstLinkValid: boolean = false;

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    isScrolled: boolean = false;
    isNotificationTabChosen: boolean = false;

    @Input() customerId: number = 0;

    constructor(
        private httpServiceCustomer: HttpServiceCustomer,
        private mainScroll: MainScrollService,
        private router: Router,
        public custCardTabService: CustCardTabService,
        private messageService: MessageService,
        private controlsService: ControlsService,
        private logger: NGXLogger
    ) {
        mainScroll.scrollChanged.subscribe((status: number) => this.onWindowScroll(status));
        custCardTabService.notificationTabChanged.subscribe((tabIndex: number) => this.onChangeTab(tabIndex));
    }

    ngOnInit() {
        this.customerin.customer_id = this.customerId;

        // Get custcard_3 data
        this.httpServiceCustomer.getCustCard_3(this.customerin)
            .subscribe((res: CustCard_3) => {
                this.custcard_3 = res;
                this.clientInit();
                if (this.custcard_3.faceBook.includes("facebook.com/")) {
                    this.custcard_3.faceBook.replace(/ /g, "");
                    this.custcard_3.faceBook = this.custcard_3.faceBook.split("facebook.com/")[1];
                    this.isFbLinkValid = true;
                }

                if (this.custcard_3.instLink.includes("instagram.com/")) {
                    this.custcard_3.instLink.replace(/ /g, "");
                    this.custcard_3.instLink = this.custcard_3.instLink.split("instagram.com/")[1];
                    this.isInstLinkValid = true;
                }

                this.getCategoriesArray();
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });


        // Get config
        this.httpServiceCustomer.getConfig()
            .subscribe((data: Config) => {
                this.config = data;
                if (this.config !== undefined) {
                    console.log("BusinessID: " + this.config.remotebusid);
                }
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get customCategories
        this.httpServiceCustomer.getCustomCategories()
            .subscribe((data: CustomCategory[]) => {
                this.customCategories = data;
                console.log("Count customCategories for view57:" + this.customCategories.length);
                this.getCategoriesArray();
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

            // //get custcard_1 data
            // this.httpServiceCustomer.getCustCard_1(this.customerin)
            //     .subscribe((res: CustCard_1) => {
            //         this.custcard_1 = res;
            //         console.log("customerId from custcard_1:", this.custcard_1.customerId);

            //         if (this.custcard_1.autoClassificationName !== '') {
            //             this.customClassificationData.push({ id: 3, name: this.custcard_1.autoClassificationName });
            //         }
            //         if (this.custcard_1.debt && this.custcard_1.debt == 2) {
            //             this.customClassificationData.push({ id: 2, name: "לקוח עם חוב" });
            //         }
            //         if (this.custcard_1.birthDay && this.custcard_1.birthDay == 1) {
            //             this.customClassificationData.push({ id: 1, name: "יום הולדת החודש" });
            //         }

            //         console.log("customClassificationData: ", this.customClassificationData);
            //     }, error => {
            //         console.log(error);
            //         this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            //     });
    }

    clientInit(): void {
        this.custcard_3.sex = this.custcard_3.sex || 0;
        this.sexdesc = this.sexData[this.custcard_3.sex];
        this.custcard_3.cityID = this.custcard_3.cityID || 0;
        this.custcard_3.recommenderCustID = this.custcard_3.recommenderCustID || 0;
        this.custcard_3.saparID = this.custcard_3.saparID || 0;
        this.custcard_3.sourceID = this.custcard_3.sourceID || 0;
        this.custcard_3.occupationId = this.custcard_3.occupationId || 0;
    }

    onWindowScroll(status: number): void {
        if (status > 10) {
            this.isScrolled = true;
        }
        else if (this.isScrolled && status < 10) {
            this.isScrolled = false;
        }
    }

    onChangeTab(tabIndex: number): void {
        if (tabIndex == 0 || tabIndex == 1) {
            this.isNotificationTabChosen = true;
        }
        else {
            this.isNotificationTabChosen = false;
        }
    }

    notificationButtonClick(index: number): void {
        this.custCardTabService.notificationTabIndex = index;
    }

    getCategoriesArray(): void {
        if (this.custcard_3.idOfCategery && this.customCategories) {
            this.categoriesArray = this.customCategories.filter((category: CustomCategory) => {
                return this.custcard_3.idOfCategery.split(";").includes(category.custCategoryId.toString());
            });
        }
    }

    getClientImageSrc(): string {
        if (this.config && this.custcard_3) {
            return "https://optimusb12023.s3.eu-north-1.amazonaws.com/" + this.config.remotebusid + "/clients/" + this.custcard_3.customerId + "/" + this.custcard_3.imagePath;
        }
    }

    clearImagePath(): void {
        this.custcard_3.imagePath = "";
    }

    openEditCustomer(custcard_3: CustCard_3): void {
        this.router.navigate(["clients", "editpersonal", custcard_3.customerId]);
    }

    isVIPCustomer(): boolean {
        if (this.custcard_3.idOfCategery && this.custcard_3.idOfCategery.includes("7")) {
            return true;
        }
    }

    // Check if the control with the given id is blurred for the user by his role
    isBlurred(id: number): boolean {
        if (this.controlsService.custcardviewControlsData) {
            let control = this.controlsService.custcardviewControlsData.find(control => control.cb_id == id);
            let blurryRole = control.cb_is_blurry_role;
            let userRole = sessionStorage.getItem("userRole");
            return +userRole < +blurryRole;
        }
    }

    // Check if the control with the given id is disabled for the user by his role
    isDisabled(id: number): boolean {
        if (this.controlsService.custcardviewControlsData) {
            let control = this.controlsService.custcardviewControlsData.find(control => control.cb_id == id);
            if (!control) {
                return false;
            }
            let enabledRole = control.cb_is_enabled_role;
            let userRole = sessionStorage.getItem("userRole");
            return +userRole < +enabledRole;
        }
    }

    invalidLink(): void {
        let errorMessage = "נראה שהלינק הזה לא תקין אנא כנסו למצב עריכה של הפרטים האישיים, ובדקו שהלינק שמוזן שם תקין/פעיל.";
        this.showMessage("error", errorMessage);
    }

    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, 3500);
        }
        else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
            else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
        }
    }
}